import { useQuery } from '@tanstack/react-query';

import { fetchOpenCalendars } from '../api';

export function useOpenCalendars() {
  const { data, isLoading, error } = useQuery({
    queryFn: fetchOpenCalendars,
    queryKey: ['my-plan/fetch-calendars'],
    refetchOnWindowFocus: false
  });

  return { data, loading: isLoading, error };
}
